import sanitizeHtml from "sanitize-html";

const memberNoteSanitizeOptions: sanitizeHtml.IOptions = {
  allowedTags: [...sanitizeHtml.defaults.allowedTags],
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    span: ["style"],
  },
  allowedStyles: {
    span: {
      "font-weight": [/^bold$/i, /^700$/, /^600$/],
      "font-style": [/^italic$/i],
      "text-decoration": [/^underline$/i],
    },
  },
};

/** Preserve inline formatting spans while editing (browser bold toggle uses styled spans). */
export function memberNoteEditorSanitize(html: string): string {
  return sanitizeHtml(html ?? "", memberNoteSanitizeOptions);
}

function isBoldWeight(weight: string): boolean {
  return weight === "bold" || weight === "700" || weight === "600" || Number(weight) >= 600;
}

function semanticMemberNoteHtml(html: string): string {
  const sanitized = memberNoteEditorSanitize(html);
  if (typeof document === "undefined") {
    return sanitizeHtml(sanitized);
  }

  const div = document.createElement("div");
  div.innerHTML = sanitized;

  for (const span of [...div.querySelectorAll("span[style]")]) {
    const element = span as HTMLSpanElement;
    const { fontWeight, fontStyle, textDecoration } = element.style;
    let replacement: HTMLElement | null = null;

    if (isBoldWeight(fontWeight)) {
      replacement = document.createElement("b");
    } else if (fontStyle === "italic") {
      replacement = document.createElement("i");
    } else if (textDecoration.includes("underline")) {
      replacement = document.createElement("u");
    }

    if (replacement) {
      replacement.innerHTML = element.innerHTML;
      element.replaceWith(replacement);
    }
  }

  return sanitizeHtml(div.innerHTML);
}

export function isMemberNoteBlank(html: string): boolean {
  const text = semanticMemberNoteHtml(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  return text.length === 0;
}

export function normalizeMemberNoteHtml(html: string): string {
  const trimmed = html.trim();
  if (!trimmed) return "";
  const normalized = semanticMemberNoteHtml(trimmed);
  return isMemberNoteBlank(normalized) ? "" : normalized;
}
